import React, { useEffect, useState } from 'react';
import { Table } from '@veneer/table';
import { Pagination, Button, IconButton, Search, Select } from '@veneer/core';
import WarrantyPreferences from './WarrantyShipments.preferences';
import ConnectAPI from '../../../services/api';
import Swal from 'sweetalert2';
import moment from 'moment';
import { numberFormatComma } from './../../../common/js/utils/numberFormat';
import XLSX from 'xlsx';
import { Trans } from 'react-i18next';
import { translate } from 'react-i18next';

const Report = (props) => {
  const configReport = {
    columns: [
      {
        column: 'id',
        title: 'ID',
        filter: {
          type: 'component',
          component: (
            <Search
              name="id-search"
              onChange={(value) =>
                handleSingleFilter({
                  column: 'id',
                  filterValue: value,
                })
              }
            />
          ),
        },
      },
      {
        column: 'channel',
        title: 'Channel',
        filter: {
          type: 'component',
          component: (
            <Search
              name="channel-search"
              onChange={(value) =>
                handleSingleFilter({
                  column: 'channel',
                  filterValue: value,
                })
              }
            />
          ),
        },
      },
      {
        column: 'customer',
        title: 'Customer',
        filter: {
          type: 'component',
          component: (
            <Search
              name="customer-search"
              onChange={(value) =>
                handleSingleFilter({
                  column: 'customer',
                  filterValue: value,
                })
              }
            />
          ),
        },
      },
      {
        column: 'pressId',
        title: 'Press Id',
        filter: {
          type: 'component',
          component: (
            <Search
              name="pressId-search"
              onChange={(value) =>
                handleSingleFilter({
                  column: 'pressId',
                  filterValue: value,
                })
              }
            />
          ),
        },
      },
      {
        column: 'type',
        title: 'Type',
        filter: {
          type: 'component',
          component: (
            <Search
              name="type-search"
              onChange={(value) =>
                handleSingleFilter({
                  column: 'type',
                  filterValue: value,
                })
              }
            />
          ),
        },
      },
      {
        column: 'email',
        title: 'E-mail Ref.',
        filter: {
          type: 'component',
          component: (
            <Search
              name="email-search"
              onChange={(value) =>
                handleSingleFilter({
                  column: 'email',
                  filterValue: value,
                })
              }
            />
          ),
        },
      },
      {
        column: 'qtyWarranty',
        title: 'Qty. Warranty',
        filter: {
          type: 'component',
          component: (
            <Search
              name="qtyWarranty-search"
              onChange={(value) =>
                handleSingleFilter({
                  column: 'qtyWarranty',
                  filterValue: value,
                })
              }
            />
          ),
        },
      },
      {
        column: 'qtyPending',
        title: 'Qty Pending',
        filter: {
          type: 'component',
          component: (
            <Search
              name="qtyPending-search"
              onChange={(value) =>
                handleSingleFilter({
                  column: 'qtyPending',
                  filterValue: value,
                })
              }
            />
          ),
        },
      },
      {
        column: 'qtyAdjusted',
        title: 'Qty Adjusted',
        filter: {
          type: 'component',
          component: (
            <Search
              name="qtyAdjusted-search"
              onChange={(value) =>
                handleSingleFilter({
                  column: 'qtyAdjusted',
                  filterValue: value,
                })
              }
            />
          ),
        },
      },
      {
        column: 'insertionDate',
        title: 'Insertion Date',
        filter: {
          type: 'component',
          component: (
            <Search
              name="insertionDate-search"
              onChange={(value) =>
                handleSingleFilter({
                  column: 'insertionDate',
                  filterValue: value,
                })
              }
            />
          ),
        },
      },
      {
        column: 'adjustmentMonth',
        title: 'Publication Adjustment Month',
        filter: {
          type: 'component',
          component: (
            <Search
              name="adjustmentMonth-search"
              onChange={(value) =>
                handleSingleFilter({
                  column: 'adjustmentMonth',
                  filterValue: value,
                })
              }
            />
          ),
        },
      },
    ],
    idColumn: 'id',
  };
  const connectApi = new ConnectAPI();
  const [preferences, setPreferences] = useState(WarrantyPreferences);
  const [showClearAllFilters, setShowClearAllFilters] = useState(false);
  const [config, setConfig] = useState(configReport);
  const [filteredColumns, setfilteredColumns] = useState([]);
  const [data, setData] = useState([]);
  const [dataResponse, setDataResponse] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingExport, setLoadingExport] = useState(false);
  const [paginationConfig, setPaginationConfig] = useState({
    currentPage: 1,
    totalItems: 1,
    pageSizeOptions: [25, 50, 100, 300],
    pageSize: 300,
  });

  const exportData = () => {
    setLoadingExport(true);
    setTimeout(() => {
      let excelData = dataResponse;
      filteredColumns.forEach((filter) => {
        excelData = excelData.filter((row) =>
          row[filter.column]
            .toString()
            .toLowerCase()
            .includes(filter.filterValue.toLowerCase())
        );
      });
      //const data = this.state.endUsers;
      //console.log(excelData);
      let headerEndUsers = [
        'id',
        'idPart',
        'description',
        'price',
        'priceFormatted',
        'pressClassification',
        'idCustomer',
        'customerName',
        'series',
      ];
      //let dataBody = [];
      //   const dataXlsx = excelData.map((item) => {
      //     return {
      //       description: item.description,
      //       idPart: item.idPart,
      //       msrp: item.msrp,
      //     };
      //   });

      const ws = XLSX.utils.json_to_sheet(excelData, {
        header: headerEndUsers,
      });
      const wb = XLSX.utils.book_new();

      const date = moment(new Date()).format('YYYYMMDDHHmm');

      const filename = 'warrantyShipments -' + date + '.xlsx';
      const ws_name = 'Balance';

      XLSX.utils.book_append_sheet(wb, ws, ws_name);
      XLSX.writeFile(wb, filename);

      setLoadingExport(false);
    }, 750);
  };
  const getData = () => {
    setIsLoading(true);
    setTimeout(() => {
      let pageData = dataResponse;
      //console.log(filteredColumns);
      filteredColumns.forEach((filter) => {
        pageData = pageData.filter((row) => {
          let z = row[filter.column]
            .toString()
            .toLowerCase()
            .includes(filter.filterValue.toLowerCase());
          return z;
        });
      });

      pageData = sortData(preferences.sortBy, pageData);
      const { pageSize, currentPage } = paginationConfig;
      const initialIndex = (currentPage - 1) * pageSize;
      const finalIndex = currentPage * pageSize;
      paginationConfig.currentPage = currentPage;
      paginationConfig.totalItems = pageData.length;
      pageData = pageData.slice(initialIndex, finalIndex);
      setData(pageData);
      setPaginationConfig(paginationConfig);
    }, 750);
    setIsLoading(false);
  };
  useEffect(() => {
    const fetchData = async () => {
      //setIsLoading(true);
      //   connectApi
      //     .get(
      //       'api/Channels/priceList',
      //       {
      //         params: {
      //           customerId: null,
      //           date: null,
      //         },
      //       },
      //       dataResponseLoad
      //     )
      //     .catch((error) => {
      //       setIsLoading(false);
      //       Swal.fire(
      //         'Error ' + error.response.status,
      //         error.response.data,
      //         'error'
      //       );
      //     });
    };

    const dataResponseLoad = (status, data) => {
      //console.log(data);
      data.map((item, key) => {
        item.id = key;
        item.priceFormatted =
          item.price == null ? '-' : numberFormatComma(item.price);
      });

      setDataResponse(data === undefined ? [] : data);
      //   setrecommendedPriceRegion(data.filter((item) => item.idCountry === 'BR'));
      //console.log(recommendedPriceRegion);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  useEffect(() => {
    getData();
  }, [
    //recommendedPriceRegion,
    dataResponse,
    paginationConfig,
    filteredColumns,
    config,
    preferences,
  ]);

  const setFilterValues = (config) => {
    //console.l;
    const newConfig = config;
    const newColumns = newConfig.columns.map((column) => {
      const newColumn = column;
      if (newColumn.filter) {
        newColumn.filter.component = React.cloneElement(
          column.filter.component,
          {
            value: getFilterValue(column.column),
          }
        );
      }
      return newColumn;
    });
    newConfig.columns = newColumns;
    return newConfig;
  };

  const sortData = (sortBy, dataToSort) => {
    //(sortBy);
    //console.log(dataToSort);
    let dataSorted;
    const { type, column } = sortBy;
    if (type === 'ASC') {
      dataSorted = dataToSort.sort((a, b) => {
        let value, x, y;
        x =
          typeof a[column] === 'object'
            ? typeof a[column] === typeof (<a />)
              ? a[column].props.href
              : a[column].props.label
            : a[column];
        y =
          typeof b[column] === 'object'
            ? typeof b[column] === typeof (<a />)
              ? b[column].props.href
              : b[column].props.label
            : b[column];
        if (x.toString().toUpperCase() > y.toString().toUpperCase()) {
          value = 1;
        } else if (y.toString().toUpperCase() > x.toString().toUpperCase()) {
          value = -1;
        } else {
          value = 0;
        }

        return value;
      });
    } else {
      dataSorted = dataToSort.sort((a, b) => {
        let value, x, y;
        x =
          typeof a[column] === 'object'
            ? typeof a[column] === typeof (<a />)
              ? a[column].props.href
              : a[column].props.label
            : a[column];
        y =
          typeof b[column] === 'object'
            ? typeof b[column] === typeof (<a />)
              ? b[column].props.href
              : b[column].props.label
            : b[column];
        if (x.toString().toUpperCase() < y.toString().toUpperCase()) {
          value = 1;
        } else if (y.toString().toUpperCase() < x.toString().toUpperCase()) {
          value = -1;
        } else {
          value = 0;
        }
        return value;
      });
    }
    return dataSorted;
  };

  const handleSingleFilter = (filteredColumn) => {
    let filteredColumnsTemp = [...filteredColumns];
    //console.log(filteredColumnsTemp);
    //const { filteredColumns, showClearAllFilters } = this.state;
    const indexOf = filteredColumnsTemp.findIndex(
      ({ column }) => column === filteredColumn.column
    );
    //console.log(indexOf);
    if (filteredColumn.filterValue) {
      if (indexOf === -1) {
        filteredColumnsTemp.push(filteredColumn);
        if (!showClearAllFilters) {
          //console.log('!oh true');
          setShowClearAllFilters(true);
        }
      } else {
        //console.log('!oh true');
        filteredColumnsTemp[indexOf] = filteredColumn;
      }
    } else if (indexOf !== -1) {
      filteredColumnsTemp.splice(indexOf, 1);
      if (filteredColumnsTemp.length === 0 && showClearAllFilters) {
        //console.log('!oh false');

        setShowClearAllFilters(false);
      }
    }
    handleFilter(filteredColumnsTemp);
  };
  //   useEffect(() => {
  //     console.log(filteredColumns);
  //     getData();
  //   }, [filteredColumns]);

  const handleFilter = (filteredColumnsData) => {
    const paginationCopy = paginationConfig;
    paginationCopy.currentPage = 1;
    setfilteredColumns((filteredColumns) => [
      //...filteredColumns,
      ...filteredColumnsData,
    ]);
  };

  const handleSort = (sortBy) => {
    preferences.sortBy = sortBy;
    setPreferences(preferences);
    getData();
  };

  const getFilterValue = (columnName) => {
    const filteredColumn = filteredColumns.find(
      ({ column }) => column === columnName
    );
    if (filteredColumn) {
      return filteredColumn.filterValue;
    }
    return undefined;
  };

  const changePageSize = (pageSize) => {
    paginationConfig.pageSize = pageSize;
    paginationConfig.currentPage = 1;
    setPaginationConfig(paginationConfig);
    getData();
  };

  const changePage = (currentPage) => {
    paginationConfig.currentPage = currentPage;
    setPaginationConfig(paginationConfig);
    //console.log(paginationConfig);

    getData();
  };
  const handleResize = (columnName, width) => {
    const updatedPreferences = JSON.parse(JSON.stringify(preferences));
    updatedPreferences.widths[columnName] = width;
    setPreferences(updatedPreferences);
  };
  return (
    <div>
      <br />
      <div
        style={{
          backgroundColor: '#f2f2f2',
          padding: '0.5%',
          // maxWidth: '760px',
        }}
      >
        <div className="row" style={{ textAlign: 'left', padding: '0.5%' }}>
          <IconButton
            icon="download"
            onClick={() => {
              exportData();
            }}
            disabled={dataResponse === 0}
            loading={loadingExport}
            title="Download Data"
            style={{
              padding: '0.5% 1%',
              // maxWidth: '760px',
            }}
          />

          {/* {renderRegionOptions()} */}
          {/* <TableConfiguration
      columns={config.columns}
      disableResetToDefault
      onChange={this.handleChange}
      preferences={preferences}
    /> */}
        </div>
        <Table
          config={setFilterValues(config)}
          data={data}
          preferences={preferences}
          loading={isLoading}
          mode="fixedHeight"
          onResize={handleResize}
          onFilter={handleFilter}
          onSort={handleSort}
          stretchColumnStyle
          showClearAllFilters={showClearAllFilters}
        >
          <Pagination
            currentPage={paginationConfig.currentPage}
            onChangePageSize={changePageSize}
            onPaginate={changePage}
            pageSize={paginationConfig.pageSize}
            pageSizeOptions={paginationConfig.pageSizeOptions}
            totalItems={paginationConfig.totalItems}
          />
        </Table>
      </div>
    </div>
  );
};

export default Report;
